import axios from 'axios';
import { SSO_URL, IS_USING_OLD_SSO, FORBIDDEN } from 'config/constants';
import ApiError from './helpers/ApiError';
import {
	API_BASE_URL,
	REQUEST_FAILED,
	HTTP_STATUS,
	DEFAULT_STATUS_CODE,
	IMPERSONATION_EXPIRED,
} from 'config/api';
import { login as loginSSO } from 'sso-auth/authenticate';
import { broadcastListen, broadcastRefresh } from 'utils/broadcast-refresh';

/**
 * Configured axios instance
 */
const http = axios.create({
	baseURL: API_BASE_URL,
	withCredentials: true,
});

/*
 * Standardize Api responses
 */

export function standardizeApiResponeSuccess(response) {
	return response.data;
}

export function standardizeApiResponeFail(error) {
	let error_code = REQUEST_FAILED;
	let error_status = DEFAULT_STATUS_CODE;

	/* istanbul ignore else */
	if (error.response) {
		error_code = error.response.data.Message;
		error_status = error.response.status;
	}

	return Promise.reject(new ApiError(error_code, error_status));
}

http.interceptors.response.use(
	standardizeApiResponeSuccess,
	standardizeApiResponeFail
);

/*
 * Authenticated request interceptor
 * Redirect to sso if the user is not logged in (session expired)
 */
export function handleAuthenticationFail(error) {
	if (error.status === HTTP_STATUS.Unauthorized) {
		if (IS_USING_OLD_SSO) {
			window.location.href = SSO_URL;
		} else {
			loginSSO();
		}

		return new Promise(() => null);
	}

	return Promise.reject(error);
}

http.interceptors.response.use(
	null, // Successful response..do nothing
	handleAuthenticationFail
);

broadcastListen();

export function handleImpersonationExpired(error) {
	if (error.status === FORBIDDEN && error.message === IMPERSONATION_EXPIRED) {
		broadcastRefresh(IMPERSONATION_EXPIRED);
		return new Promise(() => null);
	}

	return Promise.reject(error);
}

http.interceptors.response.use(null, handleImpersonationExpired);

export default http;



// WEBPACK FOOTER //
// ./src/api/http.js